<template>
  
	<div class="users-style">
		<div v-if="success != ''" class="alert alert-success" role="alert"> {{success}} </div>
	  <h4 class="atlhr-dashboard-title mt-10 pb-4 mb-0">Tax Rules<span><a v-bind:href="$api_url+'/agent'">Dashboard</a> / Tax Rules</span></h4>
	  <div class="card border-0 bg-wash no-shadow">
			  <div class="card-body container px-0">
				  <div style="text-align: right;">
					  <a class="btn btn-primary" style="color: #FFFFFF;"  @click="displaypayrunmodal()">+Create a Tax-Rule</a>
				  </div>
				  <br />
			  
				  <table class="mx-3" v-if="pending_payruncount!=0">
				  <thead>
					  <tr class="row border-bottom table-head" style="background-color: #01524B;">
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center">Rule Title</td>
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center">Fiscal year</td>
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center">Slabs</td>
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center">Max Exemption Per Month</td>
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center">Exemption Rate</td>
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center">Created On</td>
					  <td class="col-sm text-uppercase py-1 font-weight-bold align-self-center text-right">Action</td>
					  </tr>
				  </thead>
				  <tbody>
					  <tr class="row hover-bg table-row border-bottom py-2" v-for="trule in taxrules" :key="trule.id">
					  <td class="col-sm">{{trule.title}}</td>
					  <td class="col-sm">{{trule.fiscal_year}}</td>
					  <td class="col-sm">
					  Slab 0 : <br>No Tax Up to BDT {{trule.male_range}} for Male <br /> No Tax up to BDT {{trule.female_range}} for Female
					  
					  <br /><br />Slab 1 : <br /> Next BDT {{trule.slab_1_range}} ---- {{trule.slab_1_rate}}%
					  
					  <br /><br />Slab 2 : <br /> Next BDT {{trule.slab_2_range}} ---- {{trule.slab_2_rate}}%
					  
					  <br /><br />Slab 3 : <br /> Next BDT {{trule.slab_3_range}} ---- {{trule.slab_3_rate}}%
					  
					  <br /><br />Slab 4 : <br /> Next BDT {{trule.slab_4_range}} ---- {{trule.slab_4_rate}}%
					  
					  <br /><br />Slab 5 : <br /> Next BDT {{trule.slab_5_range}} ---- {{trule.slab_5_rate}}%
					  <br /><br />Slab 6 : <br /> Next BDT Remaining All ---- {{trule.slab_6_rate}}%
					  
					  
					  </td>
					  
					  <td class="col-sm">
					  <br /><br />House Rent Allowance---- BDT {{trule.hra_exemp_range}}
					  <br /><br />Conveyance Allowance ---- BDT {{trule.conv_exemp_range}}
					  <br /><br />Medical Allowance ---- BDT {{trule.medical_exemp_range}}
					  <br /><br />Max Exemption ---- BDT {{trule.max_exemption}}
					  
					  </td>
					  
					  <td class="col-sm">
					  <br /><br />House Rent Allowance----  {{trule.hra_exemp_rate}}% of Basic
					  <br /><br />Conveyance Allowance ----  N/A
					  <br /><br />Medical Allowance ----  {{trule.medical_exemp_rate}}% of Basic
					  </td>
					  
					  <td class="col-sm">{{trule.created_at}}</td>
					  <td class="col-sm" style="min-width: 190px;">
						  <b-button-toolbar class="float-right position-relative">
							  <a id="actionDropdown" class="dropdown-toggle clearfix action-dropdown-toggle" style="font-size: 16px;" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><b-icon icon="three-dots-vertical"></b-icon></a>
								  <div class="dropdown-menu action-dropdown-menu" aria-labelledby="actionDropdown">
								  <b-button-group class="mr-1">
									  <b-button title="View" @click="get_tax_rule_by_id(trule.id, 'no')">
										  <b-icon icon="eye" aria-hidden="true" ></b-icon> View
									  </b-button>
									  <b-button title="Copy Rule" @click="get_tax_rule_by_id(trule.id, 'yes')">
										  <b-icon icon="pencil" aria-hidden="true" ></b-icon> Copy Rule
									  </b-button>
								  </b-button-group>
								  </div>
							  </b-button-toolbar>
					  </td>
					  </tr>
				  </tbody>
				  <tfoot>
					  <tr>
					  <td colspan="9">
						  <!--<span class="page-stats">{{pagination.from}} - {{pagination.to}} of {{pagination.total}}</span></span>
						  <button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.prebuttonstatus" @click="setPagination(false)" > Prev </button>
						  <button v-bind:class="'btn btn-sm pagination-next btn-primary '+pagination.nextbuttonstatus"   @click="setPagination(true)"> Next </button>
						  <select class="input" type="text" v-model="per_page" @change="setSearch()">
						  <option value="5">5</option>
						  <option value="10">10</option>
						  <option value="20">20</option>
						  </select>-->
						  <div class="row p-2 float-right" >
							  <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
						  </div>
					  </td>
					  </tr>
				  </tfoot>
				  </table>
		  </div>
	  </div>
  
	  
   <div>
	<b-modal id="taxrule_modal" title="Create New Tax-Rule"  size="lg" hide-footer>  
	<!-- Modal Content Starts -->
	<b-card style="margin: 0 30px 30px 30px;">
	  <form @submit="formSubmit" enctype="multipart/form-data">
		<input class="input" type="hidden" v-model="id" >
  
		<div class="form-group row">
		  <label for="name" class="col-md-4 col-form-label">Fiscal Year</label>
		  <div class="col-md-12">
			<select id="fiscal_year" v-model="fiscal_year" name="fiscal_year" required class="form-control ">
			<option v-for='pyr in payrunyears'  :value='pyr.range'>{{ pyr.range }}</option>
			</select>
		  </div>
		</div>
		
		   <div class="form-group row">
		  <label for="name" class="col-md-4 col-form-label">Rule Title</label>
		  <div class="col-md-12">
		  <input id="title" type="text" class="form-control" required v-model="title" name="title">
		  </div>
		</div>  
		
		
		
		<div class="form-group row">
		  <div class="col-md-6">Slab-0: (No Tax) <br></div>
		  <div class="col-md-4">Third Gender Tax Exemption Range</div>
		  <div class="col-md-2">
		  <input id="third_gender_range" type="text" class="form-control" required v-model="third_gender_range" name="third_gender_range">
		  </div>
		</div>      
			 
   
	   <div class="form-group row">
		  <div class="col-md-4">Male Tax Exemption Range</div>
		  <div class="col-md-2">
		  <input id="male_range" type="text" class="form-control" required v-model="male_range" name="male_range">
		  </div>
		  
		  
		  <div class="col-md-4">Female Tax Exemption Range</div>
		  <div class="col-md-2">
		  <input id="female_range" type="text" class="form-control" required v-model="female_range" name="female_range">
		  </div>
		</div> 
		
		
		<div class="form-group row">
		  <div class="col-md-4">Gazetted Freedom Fighter Range</div>
		  <div class="col-md-2">
		  <input id="freedom_fighter_range" type="text" class="form-control" required v-model="freedom_fighter_range" name="freedom_fighter_range">
		  </div>
		  
		  
		  <div class="col-md-4">Parent/legal guardian of Disabled Range</div>
		  <div class="col-md-2">
		  <input id="disabled_guardian_range" type="text" class="form-control" required v-model="disabled_guardian_range" name="disabled_guardian_range">
		  </div>
		  </div> 
  
  
		  <div class="form-group row">
		  <div class="col-md-4">Disabled tax payer Range</div>
		  <div class="col-md-2">
		  <input id="disabled_range" type="text" class="form-control" required v-model="disabled_range" name="disabled_range">
		  </div>
		  
		  <div class="col-md-4">Senior Tax Payer (Above 65 years of age) Tax Exemption Range</div>
		  <div class="col-md-2">
		  <input id="senior_range" type="text" class="form-control" required v-model="senior_range" name="senior_range">
		  </div>
		  
		  </div>      
	  
	  <hr />
		
  
		<div class="form-group row">
		  <div class="col-md-4">Slab-1: Next BDT</div>
		  <div class="col-md-2">
		  <input id="slab_1_range" type="text" class="form-control" required v-model="slab_1_range" name="slab_1_range">
		  </div>
		  
		  
		  <div class="col-md-4">Tax Rate (%)</div>
		  <div class="col-md-2">
		  <input id="slab_1_rate" type="text" class="form-control" required v-model="slab_1_rate" name="slab_1_rate">
		  </div>
		</div> 
  
   
  
  
   
		<div class="form-group row">
		  <div class="col-md-4">Slab-2: Next BDT</div>
		  <div class="col-md-2">
		  <input id="slab_2_range" type="text" class="form-control" required v-model="slab_2_range" name="slab_2_range">
		  </div>
		  
		  
		  <div class="col-md-4">Tax Rate (%)</div>
		  <div class="col-md-2">
		  <input id="slab_2_rate" type="text" class="form-control" required v-model="slab_2_rate" name="slab_2_rate">
		  </div>
		</div> 
   
  
  
  
   
		<div class="form-group row">
		  <div class="col-md-4">Slab-3: Next BDT</div>
		  <div class="col-md-2">
		  <input id="slab_3_range" type="text" class="form-control" required v-model="slab_3_range" name="slab_3_range">
		  </div>
		  
		  
		  <div class="col-md-4">Tax Rate (%)</div>
		  <div class="col-md-2">
		  <input id="slab_3_rate" type="text" class="form-control" required v-model="slab_3_rate" name="slab_3_rate">
		  </div>
		</div> 
   
  
  
  
   
		<div class="form-group row">
		  <div class="col-md-4">Slab-4: Next BDT</div>
		  <div class="col-md-2">
		  <input id="slab_4_range" type="text" class="form-control" required v-model="slab_4_range" name="slab_4_range">
		  </div>
		  
		  
		  <div class="col-md-4">Tax Rate (%)</div>
		  <div class="col-md-2">
		  <input id="slab_4_rate" type="text" class="form-control" required v-model="slab_4_rate" name="slab_4_rate">
		  </div>
		</div> 
   
  
  
	  
		<div class="form-group row">
		  <div class="col-md-4">Slab-5: Next BDT</div>
		  <div class="col-md-2">
		  <input id="slab_5_range" type="text" class="form-control" required v-model="slab_5_range" name="slab_5_range">
		  </div>
		  
		  
		  <div class="col-md-4">Tax Rate (%)</div>
		  <div class="col-md-2">
		  <input id="slab_5_rate" type="text" class="form-control" required v-model="slab_5_rate" name="slab_5_rate">
		  </div>
		</div> 
  
		<div class="form-group row">
		  <div class="col-md-4">Slab-6: Next BDT</div>
		  <div class="col-md-2">
		  <span>Rest of all</span>
		  <input id="slab_6_range" type="hidden" class="form-control"  v-model="slab_6_range" name="slab_6_range" disabled>
		  </div>
		  
		  
		  <div class="col-md-4">Tax Rate (%)</div>
		  <div class="col-md-2">
		  <input id="slab_6_rate" type="text" class="form-control" required v-model="slab_6_rate" name="slab_6_rate">
		  </div>
		</div> 
   
  
  
		<div class="form-group row">
		  <div class="col-md-4">HRA Max. Exemption (per annum)</div>
		  <div class="col-md-2">
		  <input id="hra_exemp_range" type="text" class="form-control" required v-model="hra_exemp_range" name="hra_exemp_range">
		  </div>
		  
		  
		  <div class="col-md-4">HRA Exemption Rate (% of basic)</div>
		  <div class="col-md-2">
		  <input id="hra_exemp_rate" type="text" class="form-control" required v-model="hra_exemp_rate" name="hra_exemp_rate">
		  </div>
		</div> 
  
  
		<div class="form-group row">
		  <div class="col-md-4">Medical Max. Exemption (per annum)</div>
		  <div class="col-md-2">
		  <input id="medical_exemp_range" type="text" class="form-control" required v-model="medical_exemp_range" name="medical_exemp_range">
		  </div>
		  
		  
		  <div class="col-md-4">Medical Exemption Rate (% of basic)</div>
		  <div class="col-md-2">
		  <input id="medical_exemp_rate" type="text" class="form-control" required v-model="medical_exemp_rate" name="medical_exemp_rate">
		  </div>
		</div> 
  
  
  
		<div class="form-group row">
		  <div class="col-md-4">Conv Max. Exemption (per annum)</div>
		  <div class="col-md-2">
		  <input id="conv_exemp_range" type="text" class="form-control" required v-model="conv_exemp_range" name="conv_exemp_range">
		  </div>
		  
		  <div class="col-md-4">Investment Rebate Rate (% of total income)</div>
		  <div class="col-md-2">
		  <input id="investment_rebate_rate" type="text" class="form-control" required v-model="investment_rebate_rate" name="investment_rebate_rate">
		  </div>
		</div> 

		<!-- Max Exeption Field Updates -->
		<div class="form-group row">
		  <div class="col-md-4">Max. Exemption (per annum)</div>
		  <div class="col-md-2">
		  <input id="max_exemption" type="text" class="form-control" required v-model="max_exemption" name="max_exemption">
		  </div>
		</div> 
  
		  
		<hr />
  
		<div style="text-align: center;">Investment Rebate Settings</div>
		
		<hr />
		
		<div class="form-group row">
		  <div class="col-md-4">Enable Rebate Slabs:</div>
		  <div class="col-md-2">
			<b-form-checkbox v-model="rebet_type" name="rebet_type" switch size="lg"></b-form-checkbox>
		  </div>
		  
		  <div class="col-md-4">Rebate Rate (for one standalone rate in %)</div>
		  <div class="col-md-2">
		  <input id="rebet_slab_global_rate" type="text" class="form-control" required v-model="rebet_slab_global_rate" name="rebet_slab_global_rate">
		  </div>
		</div>
		
		<div class="form-group row">
		  <div class="col-md-2">Rebate Slab-1 Range</div>
		  <div class="col-md-2">
		  <input id="min_rebet_slab_1_range" type="text" class="form-control" v-model="min_rebet_slab_1_range" name="min_rebet_slab_1_range">
		  </div>
		  <div class="col-md-2">
		  <input id="max_rebet_slab_1_range" type="text" class="form-control" v-model="max_rebet_slab_1_range" name="max_rebet_slab_1_range">
		  </div>
		  
		  
		  <div class="col-md-2">Rebate Rate (%)</div>
		  <div class="col-md-2">
		  <input id="rebet_slab_1_rate" type="text" class="form-control" v-model="rebet_slab_1_rate" name="rebet_slab_1_rate">
		  </div>
		</div> 
  
   
  
  
   
		<div class="form-group row">
		  <div class="col-md-2">Rebate Slab-2 Range</div>
		  <div class="col-md-2">
		  <input id="min_rebet_slab_2_range" type="text" class="form-control" v-model="min_rebet_slab_2_range" name="min_rebet_slab_2_range">
		  </div>
		  <div class="col-md-2">
		  <input id="max_rebet_slab_2_range" type="text" class="form-control" v-model="max_rebet_slab_2_range" name="max_rebet_slab_2_range">
		  </div>
		  
		  
		  <div class="col-md-2">Rebate Rate (%)</div>
		  <div class="col-md-2">
		  <input id="rebet_slab_2_rate" type="text" class="form-control" v-model="rebet_slab_2_rate" name="rebet_slab_2_rate">
		  </div>
		</div> 
   
  
  
  
   
		<!--<div class="form-group row">
		  <div class="col-md-4">Investment Slab-3 Range</div>
		  <div class="col-md-2">
		  <input id="rebet_slab_3_range" type="text" class="form-control" required v-model="rebet_slab_3_range" name="rebet_slab_3_range">
		  </div>
		  
		  
		  <div class="col-md-4">Rebate Rate (%)</div>
		  <div class="col-md-2">
		  <input id="rebet_slab_3_rate" type="text" class="form-control" required v-model="rebet_slab_3_rate" name="rebet_slab_3_rate">
		  </div>
		</div>--> 
  
		
		<hr />
		
		<div style="text-align: center;">Minimum Tax</div>
  
		  <hr />
  
	   <div class="form-group row">
		  <div class="col-md-4">Dhaka City Corporation</div>
		  <div class="col-md-2">
		  <input id="mintax_dhaka_city_corporation" type="text" class="form-control" required v-model="mintax_dhaka_city_corporation" name="mintax_dhaka_city_corporation">
		  </div>
		  
		  
		  <div class="col-md-4">Chattogram City Corporation</div>
		  <div class="col-md-2">
		  <input id="mintax_chitagong_city_corporation" type="text" class="form-control" required v-model="mintax_chitagong_city_corporation" name="mintax_chitagong_city_corporation">
		  </div>
		</div> 
		
		
  
	   <div class="form-group row">
		  <div class="col-md-4">Other City Corporation</div>
		  <div class="col-md-2">
		  <input id="mintax_other_city_corporation" type="text" class="form-control" required v-model="mintax_other_city_corporation" name="mintax_other_city_corporation">
		  </div>
		  
		  
		  <div class="col-md-4">Outside of City Corporation</div>
		  <div class="col-md-2">
		  <input id="mintax_outside_of_city_corporation" type="text" class="form-control" required v-model="mintax_outside_of_city_corporation" name="mintax_outside_of_city_corporation">
		  </div>
		</div> 
		
  
	   <hr />
	   <div class="form-group row">
		  <div class="col-md-4">Non Resident Flat-Tax Rate (% of Total Income)</div>
		  <div class="col-md-2">
		  <input id="non_resident_rate" type="text" class="form-control" required v-model="non_resident_rate" name="non_resident_rate">
		  </div>
		  
		  
		  <div class="col-md-4">Max Investment Rebate Limit</div>
		  <div class="col-md-2">
		  <input id="max_inv_rebate_lim" type="text" class="form-control" required v-model="max_inv_rebate_lim" name="max_inv_rebate_lim">
		  </div>
		  
		  
		</div>  
		
		<!-- CHANGE: max_allowed_rebate_limit -->
		<div class="form-group row">
			<div class="col-md-4">Max Allowed Rebate Limit</div>
			<div class="col-md-2">
				<input id="max_allowed_rebate_limit" type="text" class="form-control" required v-model="max_allowed_rebate_limit" name="max_allowed_rebate_limit">
			</div>
		</div>
		<!-- END CHANGE: max_allowed_rebate_limit -->
				 
		  <!-- Faroque code starts here - 7th march 2022 -->
		  <div style="text-align: center;">Investment Amount Rebate Limit Per Type</div>
		  <hr />
		  
		  <div class="form-group row" >
			  <template v-for="investment_type in investment_types">
				  <template  v-if="investment_type.value > 0">
					  <div class="col-4">{{investment_type.text}}</div>
					  <div class="col-2">						
						  <b-form-input class="check_required" v-model="investment[investment_type.value]" :id="`investment_${investment_type.value}`"></b-form-input>					
					  </div>
				  </template>
			  </template>
		  </div>
				 
		  <!--------- Faroque code ends here -------------->
  
  
		<div class="form-group row" v-if="show_submit=='yes'">
		  <div class="col-md-2">
			<button class="btn btn-success btn-full-width">Submit</button>
		  </div>
		  
		  <div class="col-md-2" v-if="loading =='load'">
			<img :src="$api_url+'/images/loading.gif'" width="30">
		  </div>
		  
		</div>
	  </form>
	
	
	
  </b-card>
	  
	<!-- Modal Content Ends -->
	</b-modal>
  </div>   
	  
	  
	</div>
	
	
  </template> 
	<script>
		export default{
			props: [ 'company_name'],
			mounted() {
				console.log('started..');            
			},
			data(){
				return {
					taxrules : [], 
					payrunyears: [],
					pagination: {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', nextbuttonstatus:'true', prebuttonstatus:'disabled'},
					search_by_id: {id:''},
					per_page:100,              
					
					company_title: this.company_name,
					pending_payruncount:0,
  
					///////new payrun components starts////
					success: '',
					id: '',
					month: '',
					year: '',
					loading:'',
					///////new payrun components end////
					fiscal_year: '',
					title: '',
					female_range: '',
					male_range: '',
					freedom_fighter_range: '',
					disabled_guardian_range: '',
					disabled_range: '', 
					senior_range: '',
					third_gender_range: '',                 
					
					slab_1_range: '',
					slab_1_rate: '',
					slab_2_range: '',
					slab_2_rate: '',
					slab_3_range: '',
					slab_3_rate: '',
					slab_4_range: '',
					slab_4_rate: '',
					slab_5_range: '',
					slab_5_rate: '',
					slab_6_range: '',
					slab_6_rate: '',
					non_resident_rate: '',
					max_inv_rebate_lim: '',
					
					max_rebet_slab_1_range: '',
					min_rebet_slab_1_range: '',
					rebet_slab_1_rate: '',
					max_rebet_slab_2_range: '',
					min_rebet_slab_2_range: '',
					rebet_slab_2_rate: '',
					rebet_slab_3_range: '',
					rebet_slab_3_rate: '',
					rebet_slab_global_rate: '',
					rebet_type: '',
					
					hra_exemp_range: '',
					hra_exemp_rate: '',
					medical_exemp_range: '',
					medical_exemp_rate: '',
					conv_exemp_range: '',
					max_exemption: '',
					investment_rebate_rate: '',
					show_submit: 'yes',
					
					mintax_dhaka_city_corporation:'',
					mintax_chitagong_city_corporation:'',
					mintax_other_city_corporation:'',
					mintax_outside_of_city_corporation:'',                                    
																		  
					investment_types: [], // added by Faroque
					investment : [], // added by Faroque   
				  
				  	// CHANGE: max_allowed_rebate_limit
					max_allowed_rebate_limit: '',
					// END CHANGE: max_allowed_rebate_limit
  
				}
			},
			methods:{
				
			  // added by Faroque 
			  getInvestmentTypes: function()
			  {
				  if(!this.checkNet()) return false;
				  
				  axios.get(this.$api_url+'/investment/type' , {
					  params: {
						  
					  }
				  }).then(function(response){
					  
					  this.investment_types = response.data;                     
					  
				  }.bind(this));
			  }, 
				
				   getpayrunyears: function()
				{
	
							axios.get(this.$api_url+'/getfiscalyears' , {
								params: {
									page: 1,
									per_page: 10,
									search_query: this.search,
									search_query_by_id: '',
								}
						}).then(function(response){
						this.payrunyears = response.data;
	
	
					}.bind(this));
				},
  
				
			
				
				displaypayrunmodal: function()
				{
				  this.success= '';
				  this.month='';
				  this.year='';
				  this.show_submit='yes';
				  
						  this.fiscal_year= '';
						  this.title= '';
						  this.female_range= '';
						  this.male_range= '';                        
						  this.slab_1_range= '';
						  this.slab_1_rate= '';
						  this.slab_2_range= '';
						  this.slab_2_rate= '';
						  this.slab_3_range= '';
						  this.slab_3_rate= '';
						  this.slab_4_range= '';
						  this.slab_4_rate= '';
						  this.slab_5_range= '';
						  this.slab_5_rate= '';
						  this.slab_6_range= '';
						  this.slab_6_rate= '';
						  
						  this.min_rebet_slab_1_range = '';
						  this.max_rebet_slab_1_range = '';
						  this.rebet_slab_1_rate = '';
						  this.min_rebet_slab_2_range = '';
						  this.max_rebet_slab_2_range = '';
						  this.rebet_slab_2_rate = '';
						  this.rebet_slab_3_range = '';
						  this.rebet_slab_3_rate = '';
						  this.rebet_slab_global_rate = '';
						  this.rebet_type = '';
						  
						  this.hra_exemp_range= '';
						  this.hra_exemp_rate= '';
						  this.medical_exemp_range= '';
						  this.medical_exemp_rate= '';
						  this.conv_exemp_range= '';
						  this.max_exemption= '';
						  this.investment_rebate_rate= '';
						  
						  this.freedom_fighter_range= '',
						  this.disabled_guardian_range= '',
						  this.senior_range = '',
						  this.disabled_range= '',
						  this.third_gender_range  = '',
						  this.non_resident_rate= '',
						  this.max_inv_rebate_lim='', 
						  
						  // CHANGE: max_allowed_rebate_limit
						  this.max_allowed_rebate_limit = '',
						  // END CHANGE: max_allowed_rebate_limit
  
						  this.investment = []; // added by Faroque
  
  
				  this.$bvModal.show('taxrule_modal');
				},
				
				
				
				   formSubmit(e) {
	
					e.preventDefault();
	
					let currentObj = this;
	
					this.loading='load';
	
					const config = {
	
						headers: { 'content-type': 'multipart/form-data' }
	
					}
	
	
					let formData = new FormData();
  
					formData.append('fiscal_year', this.fiscal_year);
					formData.append('title', this.title);
					formData.append('female_range', this.female_range);
					formData.append('male_range', this.male_range);
					formData.append('slab_1_range', this.slab_1_range);
					formData.append('slab_1_rate', this.slab_1_rate);
					formData.append('slab_2_range', this.slab_2_range);
					formData.append('slab_2_rate', this.slab_2_rate);
					formData.append('slab_3_range', this.slab_3_range);
					formData.append('slab_3_rate', this.slab_3_rate);
					formData.append('slab_4_range', this.slab_4_range);
					formData.append('slab_4_rate', this.slab_4_rate);
					formData.append('slab_5_range', this.slab_5_range);
					formData.append('slab_5_rate', this.slab_5_rate);
					formData.append('slab_6_range', 0);
					formData.append('slab_6_rate', this.slab_6_rate);
					formData.append('hra_exemp_range', this.hra_exemp_range);
					formData.append('hra_exemp_rate', this.hra_exemp_rate);
					formData.append('medical_exemp_range', this.medical_exemp_range);
					formData.append('medical_exemp_rate', this.medical_exemp_rate);
					formData.append('conv_exemp_range', this.conv_exemp_range);
					formData.append('max_exemption', this.max_exemption);
					formData.append('investment_rebate_rate', this.investment_rebate_rate);
					
					formData.append('min_rebet_slab_1_range', this.min_rebet_slab_1_range);
					formData.append('max_rebet_slab_1_range', this.max_rebet_slab_1_range);
					formData.append('rebet_slab_1_rate', this.rebet_slab_1_rate);
					formData.append('min_rebet_slab_2_range', this.min_rebet_slab_2_range);
					formData.append('max_rebet_slab_2_range', this.max_rebet_slab_2_range);
					formData.append('rebet_slab_2_rate', this.rebet_slab_2_rate);
					formData.append('rebet_slab_global_rate', this.rebet_slab_global_rate);
					formData.append('rebet_type', this.rebet_type);
					
					formData.append('freedom_fighter_range', this.freedom_fighter_range);
					formData.append('disabled_guardian_range', this.disabled_guardian_range);
					formData.append('senior_range', this.senior_range);
					formData.append('third_gender_range', this.third_gender_range);
				  
					
					formData.append('disabled_range', this.disabled_range);
					formData.append('non_resident_rate', this.non_resident_rate);  
					formData.append('max_inv_rebate_lim', this.max_inv_rebate_lim);   
					
					// CHANGE: max_allowed_rebate_limit
					formData.append('max_allowed_rebate_limit', this.max_allowed_rebate_limit);
					// END CHANGE: max_allowed_rebate_limit
								  
					
														
  
					formData.append('mintax_dhaka_city_corporation', this.mintax_dhaka_city_corporation);
					formData.append('mintax_chitagong_city_corporation', this.mintax_chitagong_city_corporation);
					formData.append('mintax_other_city_corporation', this.mintax_other_city_corporation);
					formData.append('mintax_outside_of_city_corporation', this.mintax_outside_of_city_corporation);                                                                                                            
														
  
					  // Faroque Code Starts Here
					  let obj  = [];				
					  for (var i = 1; i < this.investment_types.length; i++) 
					  {					                         
						  obj[i] = i+'_'+`${document.getElementById("investment_"+i).value}`;
					  }
					  formData.append('elligable_investment_limit', obj); 
  
					  // Faroque Code Ends Here
  
					axios.post(this.$api_url+'/taxrulestorevue', formData, config)
	
					.then(function (response) {
						currentObj.loading='';
						currentObj.success = response.data.success;
						currentObj.$bvModal.hide('taxrule_modal');
						currentObj.gettaxrules();
						 
	
					})
	
					.catch(function (error) {
	
						currentObj.output = error;
	
					});
	
				},
  
  
			
			  
				setSearch: function(pageflg)
				{
					this.pagination.currentPage = 1;
					this.gettaxrules();
				   
				},
				setPagination: function(pageflg)
				{                
					if(pageflg)
						this.pagination.currentPage = this.pagination.nextPage;
					else    
						this.pagination.currentPage = this.pagination.prevPage;
					
					this.gettaxrules();
				},
				gettaxrules: function()
				{
					  //this.search_by_id.id=1;
	
							axios.get(this.$api_url+'/list-taxrules/1/0' , {
								params: {
									page: this.pagination.currentPage,
									per_page: this.per_page,
									search_query: this.search,
								   // search_query_by_id: this.search_by_id,
								}
						}).then(function(response){
						 
						 //alert(response.data.data[0]['id']);
						 
						this.taxrules = response.data.data;
						this.pending_payruncount=this.taxrules.length;
						this.pagination.from = response.data.from;
						this.pagination.to = response.data.to;
						this.pagination.total = response.data.total;
						
						if(this.pagination.to==this.pagination.total)
						{
							
							this.pagination.nextbuttonstatus = 'disabled';
							
						}
						else
						{
							 this.pagination.nextbuttonstatus = '';
						}
						
						if(this.pagination.from==1)
						{
						this.pagination.prebuttonstatus = 'disabled';
						}
						else
						{
						   this.pagination.prebuttonstatus = ''; 
						}
	
	
	
						if(this.pagination.currentPage < response.data.last_page)
							this.pagination.nextPage = this.pagination.currentPage + 1;
	
						if(this.pagination.currentPage == 1)
							this.pagination.prevPage = 1;
						else 
							this.pagination.prevPage = this.pagination.currentPage - 1;
					}.bind(this));
				},
				
				
				
				get_tax_rule_by_id: function(id, show_button_flag)
				{
					  this.search_by_id.id=id;
					  this.show_submit=show_button_flag;
	
							axios.get(this.$api_url+'/list-taxrules/1/0' , {
								params: {
									page: this.pagination.currentPage,
									per_page: this.per_page,
									search_query: this.search,
									search_query_by_id: this.search_by_id,
								}
						}).then(function(response){
						 
						 //alert(response.data.data[0]['id']);
						  
						  this.fiscal_year= response.data.data[0]['fiscal_year'];
						  
						  if(show_button_flag=='no')
						  this.title= response.data.data[0]['title'];
						  else
						  this.title= "Copy of "+response.data.data[0]['title'];
						  
						  this.female_range= response.data.data[0]['female_range'];
						  this.male_range= response.data.data[0]['male_range'];
							
						  this.freedom_fighter_range= response.data.data[0]['freedom_fighter_range'];
						  this.disabled_guardian_range= response.data.data[0]['disabled_guardian_range'];
						  this.disabled_range= response.data.data[0]['disabled_range'];
						  this.senior_range= response.data.data[0]['senior_range'];
						  this.third_gender_range= response.data.data[0]['third_gender_range'];
						  
						  this.non_resident_rate= response.data.data[0]['non_resident_rate'];
						  this.max_inv_rebate_lim= response.data.data[0]['max_inv_rebate_lim'];

						  // CHANGE: max_allowed_rebate_limit
						  this.max_allowed_rebate_limit= response.data.data[0]['max_allowed_rebate_limit'];
						  // END CHANGE: max_allowed_rebate_limit
  
						  this.slab_1_range= response.data.data[0]['slab_1_range'];
						  this.slab_1_rate= response.data.data[0]['slab_1_rate'];
						  this.slab_2_range= response.data.data[0]['slab_2_range'];
						  this.slab_2_rate= response.data.data[0]['slab_2_rate'];
						  this.slab_3_range= response.data.data[0]['slab_3_range'];
						  this.slab_3_rate= response.data.data[0]['slab_3_rate'];
						  this.slab_4_range= response.data.data[0]['slab_4_range'];
						  this.slab_4_rate= response.data.data[0]['slab_4_rate'];
						  this.slab_5_range= response.data.data[0]['slab_5_range'];
						  this.slab_5_rate= response.data.data[0]['slab_5_rate'];
						  this.slab_6_range= response.data.data[0]['slab_6_range'];
						  this.slab_6_rate= response.data.data[0]['slab_6_rate'];
						  
						  this.min_rebet_slab_1_range= response.data.data[0]['min_rebet_slab_1_range'];
						  this.max_rebet_slab_1_range= response.data.data[0]['max_rebet_slab_1_range'];
						  this.rebet_slab_1_rate= response.data.data[0]['rebet_slab_1_rate'];
						  this.min_rebet_slab_2_range= response.data.data[0]['min_rebet_slab_2_range'];
						  this.max_rebet_slab_2_range= response.data.data[0]['max_rebet_slab_2_range'];
						  this.rebet_slab_2_rate= response.data.data[0]['rebet_slab_2_rate'];
						  this.rebet_slab_global_rate= response.data.data[0]['rebet_slab_global_rate'];
						  this.rebet_type= response.data.data[0]['rebet_type'];
						  
						  this.hra_exemp_range= response.data.data[0]['hra_exemp_range'];
						  this.hra_exemp_rate= response.data.data[0]['hra_exemp_rate'];
						  this.medical_exemp_range= response.data.data[0]['medical_exemp_range'];
						  this.medical_exemp_rate= response.data.data[0]['medical_exemp_rate'];
						  this.conv_exemp_range= response.data.data[0]['conv_exemp_range'];
						  this.max_exemption= response.data.data[0]['max_exemption'];
						  this.investment_rebate_rate= response.data.data[0]['investment_rebate_rate'];
  
						  this.mintax_dhaka_city_corporation= response.data.data[0]['mintax_dhaka_city_corporation']; 
						  this.mintax_chitagong_city_corporation= response.data.data[0]['mintax_chitagong_city_corporation'];
						  this.mintax_other_city_corporation= response.data.data[0]['mintax_other_city_corporation'];
						  this.mintax_outside_of_city_corporation= response.data.data[0]['mintax_outside_of_city_corporation'];
  
						  this.investment = response.data.data[0]['investment_eligible_limit']; // Added By Faroque
						  
						  this.$bvModal.show('taxrule_modal');
						  
					}.bind(this));
				},
				
				
				
				
	
			},
			
			created: function(){
				this.getpayrunyears();
				this.gettaxrules();
				
				this.getInvestmentTypes(); // Added By Faroque
		  
			}
		}
	</script>
	<style>
	button.disabled{
		cursor: default;
	}
	
	.tb-border{
	  border: 1px solid #808080;
	  border-radius: 0.25rem !important;
	  border-collapse: separate;
  }
  
  .tb-border td{
	  padding: 2px !important;
  }
	
	</style>